const t = "{{currentTime}} trên tổng số {{duration}}", n = "Kết quả tìm kiếm {{current}} trên {{total}}", c = "Không tìm thấy kết quả", T = "{{count}} kết quả được tìm thấy", o = "{{count}} kết quả được tìm thấy", A = 'Đang phát từ $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) và $t(SECONDS, { "count": {{seconds}} }).', E = 'Đang phát từ $t(MINUTES, { "count": {{minutes}} }) và $t(SECONDS, { "count": {{seconds}} }).', s = 'Đang phát từ $t(SECONDS, { "count": {{seconds}} }).', _ = "Lỗi khi lưu thay đổi vào bản chép lời.", h = "Dòng trong bản chép lời tại {{time}}. Nội dung là: {{text}}.", S = 'Vùng chứa các dòng trong bản chép lời. Có $t(TRANSCRIPT_LINES, { "count": {{count}} }) trong vùng chứa này. Để điều hướng bên trong vùng chứa này, hãy sử dụng phím mũi tên xuống.', N = "Đang lưu thay đổi...", i = "Thay đổi đã được lưu vào bản chép lời.", C = "Nút cập nhật chú thích hiện đã khả dụng.", R = "Thao tác", O = "Thêm chú thích tại {{time}}", I = "Thêm câu hỏi lúc {{time}}", g = "Chú thích", P = "Tự động", L = "Tự động ({{quality}})", U = "Quay lại", u = "Phụ Đề", M = "Ngôn Ngữ Phụ Đề", D = "Quản Lý Chú Thích", e = "Xóa {{language}}", m = "Cỡ Chữ", a = "Ngôn Ngữ Phụ Đề: {{language}}", r = "{{language}} (tự động)", p = "Xóa Tìm Kiếm", l = "Đóng", G = "Bình Luận", Y = "Tiếp tục", B = "Giảm Tốc Độ Phát Lại", y = "Giảm Âm Lượng thêm {{percent}}%", H = "Mũi Tên Xuống", K = "Đóng Trình Chỉnh Sửa Bản Chép Lời", V = "Cập Nhật Chú Thích", b = "Lỗi!", d = "Đang lưu...", k = "Đã lưu!", v = "Chỉnh Sửa Bản Chép Lời", F = "Văn bản không được bỏ trống!", Q = "Toàn Màn Hình", q = "{{count}} giờ", W = "{{count}} giờ", $ = "Tăng Tốc Độ Phát Lại", J = "Tăng Âm Lượng thêm {{percent}}%", X = "Đảo Ngược Màu", x = "Nhảy đến phần trăm cụ thể (1-10%, 2-20%, v.v.)", Z = "Nhảy đến Bắt Đầu", f = "Thao Tác cho {{title}}", j = "Phím Tắt", w = "Ngôn Ngữ", z = "Mũi Tên Trái", tt = "Menu Chính", nt = "{{count}} phút", ct = "{{count}} phút", Tt = "Tắt Tiếng", ot = "Đã Tắt Tiếng", At = "Ngôn Ngữ Phụ Đề Tiếp Theo", Et = "Kết quả tìm kiếm tiếp theo", st = "Tắt", _t = "Ở Trên Cùng", ht = "Mở chú thích tại {{time}}", St = "Mở bài kiểm tra đã hoàn thành tại {{time}}", Nt = "Mở bài kiểm tra tại {{time}}", it = "Tạm Dừng", Ct = "Phát", Rt = "Tốc Độ Phát Lại", Ot = "Tốc Độ Phát Lại: {{speed}}x", It = "Ngôn Ngữ Trước Đó của Phụ Đề", gt = "Kết quả tìm kiếm trước đó", Pt = "Chất Lượng", Lt = "Menu Chất Lượng", Ut = "Phát Lại", ut = "Đặt Lại Tốc Độ Phát Lại", Mt = "Mũi Tên Phải", Dt = "Tìm kiếm trong bản chép lời", et = "{{count}} giây", mt = "{{count}} giây", at = "Tua lùi: {{seconds}} giây", rt = "Tua tiến: {{seconds}} giây", pt = "Cài Đặt", lt = "Lối Tắt", Gt = "Chi tiết và công cụ phương tiện", Yt = "Khoảng cách", Bt = "Menu tốc độ phát lại", yt = "Bắt Đầu Cuộn Tự Động", Ht = "Bật/Tắt Phụ Đề", Kt = "Bật/Tắt Tắt Tiếng", Vt = "Bật/Tắt Phát/Tạm Dừng", bt = "là {{count}} dòng trong bản chép lời", dt = "là {{count}} dòng trong bản chép lời", kt = "Đang tải bản chép lời...", vt = "Chúng tôi không thể tải bản chép lời.", Ft = "Các Tùy Chọn Bản Chép Lời", Qt = "Thử Lại", qt = "Không có sẵn bản chép lời", Wt = "Mũi Tên Lên", $t = "Cài Đặt Video", Jt = "Âm Lượng", Xt = "Âm Lượng: {{volume}}%", xt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: n,
  A11Y_SEARCH_NO_RESULTS: c,
  A11Y_SEARCH_RESULTS_FOUND: T,
  A11Y_SEARCH_RESULTS_FOUND_other: o,
  A11Y_TIMESTAMP_JUMP_HOURS: A,
  A11Y_TIMESTAMP_JUMP_MINUTES: E,
  A11Y_TIMESTAMP_JUMP_SECONDS: s,
  A11Y_TRANSCRIPT_ERROR: _,
  A11Y_TRANSCRIPT_LINE: h,
  A11Y_TRANSCRIPT_LINES: S,
  A11Y_TRANSCRIPT_SAVING: N,
  A11Y_TRANSCRIPT_SUCCESS: i,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: C,
  ACTION: R,
  ADD_ANNOTATION_AT: O,
  ADD_QUESTION_AT: I,
  ANNOTATIONS: g,
  AUTO: P,
  AUTO_QUALITY: L,
  BACK: U,
  CAPTIONS: u,
  CAPTIONS_LANGUAGE: M,
  CAPTIONS_MANAGE: D,
  CAPTION_DELETE: e,
  CAPTION_FONT_SIZE: m,
  CAPTION_LANGUAGE: a,
  CAPTION_LANGUAGE_AUTOMATIC: r,
  CLEAR_SEARCH: p,
  CLOSE: l,
  COMMENTS: G,
  CONTINUE: Y,
  DECREASE_PLAYBACK_SPEED: B,
  DECREASE_VOLUME: y,
  DOWN_ARROW: H,
  EDIT_CLOSE: K,
  EDIT_CONFIRM: V,
  EDIT_ERROR: b,
  EDIT_SAVING: d,
  EDIT_SUCCESS: k,
  EDIT_TRANSCRIPT: v,
  EDIT_VALIDATION_ERROR: F,
  FULLSCREEN: Q,
  HOURS: q,
  HOURS_other: W,
  INCREASE_PLAYBACK_SPEED: $,
  INCREASE_VOLUME: J,
  INVERT_COLORS: X,
  JUMP_TO_PERCENTAGE: x,
  JUMP_TO_START: Z,
  KEBAB_MENU: f,
  KEYBOARD_SHORTCUTS: j,
  LANGUAGE: w,
  LEFT_ARROW: z,
  MAIN_MENU: tt,
  MINUTES: nt,
  MINUTES_other: ct,
  MUTE: Tt,
  MUTED: ot,
  NEXT_CAPTION_LANGUAGE: At,
  NEXT_HIT: Et,
  OFF: st,
  ON_TOP: _t,
  OPEN_ANNOTATION_AT: ht,
  OPEN_COMPLETED_QUIZ_AT: St,
  OPEN_QUIZ_AT: Nt,
  PAUSE: it,
  PLAY: Ct,
  PLAYBACK_SPEED: Rt,
  PLAYBACK_SPEED_MESSAGE: Ot,
  PREVIOUS_CAPTION_LANGUAGE: It,
  PREVIOUS_HIT: gt,
  QUALITY: Pt,
  QUALITY_MENU: Lt,
  REPLAY: Ut,
  RESET_PLAYBACK_SPEED: ut,
  RIGHT_ARROW: Mt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Dt,
  SECONDS: et,
  SECONDS_other: mt,
  SEEK_BACKWARD: at,
  SEEK_FORWARD: rt,
  SETTINGS: pt,
  SHORTCUT: lt,
  SIDEBAR: Gt,
  SPACE: Yt,
  SPEED_MENU: Bt,
  START_AUTOSCROLL: yt,
  TOGGLE_CAPTIONS: Ht,
  TOGGLE_MUTED: Kt,
  TOGGLE_PLAY_PAUSE: Vt,
  TRANSCRIPT_LINES: bt,
  TRANSCRIPT_LINES_other: dt,
  TRANSCRIPT_LOADING: kt,
  TRANSCRIPT_LOAD_ERROR: vt,
  TRANSCRIPT_OPTIONS: Ft,
  TRANSCRIPT_RETRY: Qt,
  TRANSCRIPT_UNAVAILABLE: qt,
  UP_ARROW: Wt,
  VIDEO_SETTINGS: $t,
  VOLUME: Jt,
  VOLUME_VALUE: Xt
};
export {
  t as A11Y_DURATION,
  n as A11Y_SEARCH_HITS,
  c as A11Y_SEARCH_NO_RESULTS,
  T as A11Y_SEARCH_RESULTS_FOUND,
  o as A11Y_SEARCH_RESULTS_FOUND_other,
  A as A11Y_TIMESTAMP_JUMP_HOURS,
  E as A11Y_TIMESTAMP_JUMP_MINUTES,
  s as A11Y_TIMESTAMP_JUMP_SECONDS,
  _ as A11Y_TRANSCRIPT_ERROR,
  h as A11Y_TRANSCRIPT_LINE,
  S as A11Y_TRANSCRIPT_LINES,
  N as A11Y_TRANSCRIPT_SAVING,
  i as A11Y_TRANSCRIPT_SUCCESS,
  C as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  R as ACTION,
  O as ADD_ANNOTATION_AT,
  I as ADD_QUESTION_AT,
  g as ANNOTATIONS,
  P as AUTO,
  L as AUTO_QUALITY,
  U as BACK,
  u as CAPTIONS,
  M as CAPTIONS_LANGUAGE,
  D as CAPTIONS_MANAGE,
  e as CAPTION_DELETE,
  m as CAPTION_FONT_SIZE,
  a as CAPTION_LANGUAGE,
  r as CAPTION_LANGUAGE_AUTOMATIC,
  p as CLEAR_SEARCH,
  l as CLOSE,
  G as COMMENTS,
  Y as CONTINUE,
  B as DECREASE_PLAYBACK_SPEED,
  y as DECREASE_VOLUME,
  H as DOWN_ARROW,
  K as EDIT_CLOSE,
  V as EDIT_CONFIRM,
  b as EDIT_ERROR,
  d as EDIT_SAVING,
  k as EDIT_SUCCESS,
  v as EDIT_TRANSCRIPT,
  F as EDIT_VALIDATION_ERROR,
  Q as FULLSCREEN,
  q as HOURS,
  W as HOURS_other,
  $ as INCREASE_PLAYBACK_SPEED,
  J as INCREASE_VOLUME,
  X as INVERT_COLORS,
  x as JUMP_TO_PERCENTAGE,
  Z as JUMP_TO_START,
  f as KEBAB_MENU,
  j as KEYBOARD_SHORTCUTS,
  w as LANGUAGE,
  z as LEFT_ARROW,
  tt as MAIN_MENU,
  nt as MINUTES,
  ct as MINUTES_other,
  Tt as MUTE,
  ot as MUTED,
  At as NEXT_CAPTION_LANGUAGE,
  Et as NEXT_HIT,
  st as OFF,
  _t as ON_TOP,
  ht as OPEN_ANNOTATION_AT,
  St as OPEN_COMPLETED_QUIZ_AT,
  Nt as OPEN_QUIZ_AT,
  it as PAUSE,
  Ct as PLAY,
  Rt as PLAYBACK_SPEED,
  Ot as PLAYBACK_SPEED_MESSAGE,
  It as PREVIOUS_CAPTION_LANGUAGE,
  gt as PREVIOUS_HIT,
  Pt as QUALITY,
  Lt as QUALITY_MENU,
  Ut as REPLAY,
  ut as RESET_PLAYBACK_SPEED,
  Mt as RIGHT_ARROW,
  Dt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  et as SECONDS,
  mt as SECONDS_other,
  at as SEEK_BACKWARD,
  rt as SEEK_FORWARD,
  pt as SETTINGS,
  lt as SHORTCUT,
  Gt as SIDEBAR,
  Yt as SPACE,
  Bt as SPEED_MENU,
  yt as START_AUTOSCROLL,
  Ht as TOGGLE_CAPTIONS,
  Kt as TOGGLE_MUTED,
  Vt as TOGGLE_PLAY_PAUSE,
  bt as TRANSCRIPT_LINES,
  dt as TRANSCRIPT_LINES_other,
  kt as TRANSCRIPT_LOADING,
  vt as TRANSCRIPT_LOAD_ERROR,
  Ft as TRANSCRIPT_OPTIONS,
  Qt as TRANSCRIPT_RETRY,
  qt as TRANSCRIPT_UNAVAILABLE,
  Wt as UP_ARROW,
  $t as VIDEO_SETTINGS,
  Jt as VOLUME,
  Xt as VOLUME_VALUE,
  xt as default
};
